import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
        marginTop: '170px',
    },
    subMenuBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '50px',
        width: '100%',
        top: '82px',
        zIndex: 1000,
        left: '0px',
        backgroundColor: theme.palette.primary.main,
        '& span': {
            margin: '0 10px',
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            top: '100px',
        },
        position: 'fixed',
    },
    title: {
        fontSize: '24px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
    lastUpdatedTextWrapperContainer: {
        [theme.breakpoints.down('lg')]: {
            minWidth: '100%',
            marginTop: '10px',
        },
        [theme.breakpoints.only('xs')]: {
            marginTop: '12px',
        },
    },
    pagination: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        padding: '20px',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    clearFilterButton: { textTransform: 'capitalize', fontSize: '12px', marginTop: '10px' },
    filterContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        gap: '5px',
        justifyContent: 'center',
    },
}));
